var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SessionProvider } from 'next-auth/react';
import '../../scss/custom.scss';
import '../../styles/styles.css';
import SSRProvider from 'react-bootstrap/SSRProvider';
import { useRouter } from 'next/router';
import { IntlProvider } from 'react-intl';
import sv from '../../lang/sv.json';
import en from '../../lang/en.json';
import '../../styles/shared.css';
import LogRocket from 'logrocket';
const messages = {
    sv,
    en,
};
// Use of the <SessionProvider> is mandatory to allow components that call
// `useSession()` anywhere in your application to access the `session` object.
export default function App(_a) {
    var { Component } = _a, _b = _a.pageProps, { session } = _b, pageProps = __rest(_b, ["session"]);
    // refetchInterval={5 * 60}
    const { locale = 'sv' } = useRouter();
    if (process.env.NODE_ENV === 'development') {
        LogRocket.init('q1bvhf/time-to-rock');
    }
    return (<SSRProvider>
      <IntlProvider locale={locale} messages={messages[locale]}>
        <SessionProvider session={session}>
          <Component {...pageProps}/>
        </SessionProvider>
      </IntlProvider>
    </SSRProvider>);
}
